import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';
import AudioCollectionLoading from '../../../components/skeletonLoading/audioCollectionLoading/AudioCollectionLoading';

const AudiobookCollection = () => {

  const {id} = useParams();

  // In a real app with React Router, you would use:
  // import { useParams } from 'react-router-dom';
  // const { item_id } = useParams();
  

  
  const [collectionData, setCollectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("item id  === ", id);
    // Fetch collection data when component mounts or item_id changes
    if (id) {
      console.log('Fetching collection data for id:', id);
      fetchCollectionData();
    }
  }, [id]);


   const navigate = useNavigate();


  const handleClick = (item_id) => {
    navigate(`/audio/book-series/${item_id}`);
    
  };
  
  const fetchCollectionData = async () => {
    console.log("fetching collection data");
    try {
      setLoading(true);
      const response = await fetch('https://snsapiv2.baganit.com/api/app/audio/collection/detail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          collection_id: parseInt(id)
        })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      if (data.status === 1) {
        console.log(data);
        setCollectionData(data);
      } else {
        throw new Error(data.message || 'Failed to load collection');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AudioCollectionLoading />
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="text-center bg-white p-6 rounded-xl shadow-sm max-w-sm w-full">
          <div className="text-red-500 text-xl mb-3">⚠️</div>
          <p className="text-gray-800 mb-2 font-medium">Error loading collection</p>
          <p className="text-gray-600 text-sm mb-4">{error}</p>
          <button 
            onClick={fetchCollectionData}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors text-sm font-medium"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">

      {/* Content */}
      <div className="space-y-4 pt-10">
        {collectionData?.series?.map((book, index) => (
          <div 
            key={book.item_id}
            className="cursor-pointer relative"
            onClick={() => handleClick(book.item_id)}
          >
            <div className="p-6">
              {/* Book Cover with negative top margin to overlap */}
              <div className="absolute left-10 -mt-6 z-1">
                <div className="w-16 h-20 rounded-lg overflow-hidden shadow-lg">
                  <img
                    src={book.image}
                    alt={book.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `
                        <div class="flex items-center justify-center h-full bg-gradient-to-br from-blue-100 to-blue-200">
                          <div class="text-center text-blue-600">
                            <div class="text-lg">📚</div>
                          </div>
                        </div>
                      `;
                    }}
                  />
                </div>
              </div>

              {/* First Row: Gray background with Title/Author + Chevron */}
              <div className="flex bg-gray-300 rounded-xl px-4 py-4 items-center mb-4">
                {/* Space for the overlapping image */}
                <div className="flex-shrink-0 mr-6 w-16">
                  {/* Empty space where image overlaps */}
                </div>

                {/* Title and Author */}
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-sm text-gray-900 mb-1 leading-tight">
                    {book.title}
                  </h4>
                  <p className="text-gray-600 text-base">
                    {book.author_name}
                  </p>
                </div>

                {/* Chevron */}
                <ChevronRight className="w-6 h-6 text-gray-500" />
              </div>

              {/* Second Row: Summary */}
              <div className="mt-1">
                <p className="text-gray-700 text-sm leading-relaxed">
                  {book.summary}
                </p>
              </div>
            </div>
          </div>
        )) || (
          // Show message when no data is available
          !loading && !error && (
            <div className="text-center py-8">
              <p className="text-gray-500">No audiobooks found in this collection.</p>
            </div>
          )
        )}
      </div>

      {/* Bottom Spacing */}
      <div className="h-6"></div>
    </div>
  );
};

export default AudiobookCollection;